app.directive('offerte', ['bezoeker', 'globals', '$http', '$window', '$timeout', function(bezoeker, globals, $http, $window, $timeout){
	return {
		restrict: 'EAC',
		scope: {
			affiliate: '=?',
			affiliateId: '@?',
			affiliateLogo: '@?',
			affiliateBank: '@?',
			dubbelcheck: '@?',
			iframe: '=?',
			hkil: '=?',
			gewensteBank: '@?',
			trustpilotScore: '@?',
			// Data voor een custom offerte pagina
			breadcrumbs: '=?',
			showTrustpilot: '=?',
			titel: '@?',
			tekst: '@?',
		},
		templateUrl: '/templates/offerte.html',
		link: function($scope, $element) {

			$scope.interests = {};
			$scope.offerte = {};
			$scope.offerte.bezoeker = bezoeker;
			$scope.durationOptions = {};
			$scope.paymentOptions = {};
			$scope.offerte.duration = $scope.offerte.bezoeker.looptijd;
			$scope.offerte.payment = $scope.offerte.bezoeker.maandlast;

			$scope.setDurationOptions = function()
			{
				if ($scope.interests['pl'] !== 'undefined') {
					$scope.durationOptions = $scope.interests['pl'][$scope.offerte.bezoeker.gewenstLeenbedrag];
					if (typeof $scope.durationOptions['options'][$scope.offerte.duration] == 'undefined') {
						$scope.offerte.duration = $scope.durationOptions['options'][Object.keys($scope.durationOptions['options'])[Object.keys($scope.durationOptions['options']).length - 1]].duration;
					}
				}
			}

			$scope.setPaymentOptions = function()
			{
				if($scope.interests['dk'] !== 'undefined'){
					$scope.paymentOptions = $scope.interests['dk'][$scope.offerte.bezoeker.gewenstLeenbedrag];
				}
			}

			$scope.onSubmit = function(e)
			{
				$scope.isSaving = true;
				$scope.disableAddress = false;

				e.preventDefault();

				var form = angular.element('#form-offer');

				$( 'input[ng-model]:not([type="checkbox"])' ).each( function() {
					angular.element( this ).controller( 'ngModel' ).$setViewValue( $( this ).val() );
				});

				$scope.offerteForm.dirtyCheck.$setViewValue($scope.offerteForm.dirtyCheck.$viewValue);

				if($scope.offerteForm.productvorm === ''){
					return false;
				}

				bezoeker.store();

				if($scope.offerteForm.$valid)
				{
					$scope.offerte.bezoeker.offerteAangevraagd = true;
					$scope.offerte.bezoeker.store(true);
					form.submit();
				}else{
					$scope.isSaving = false;
					var invalid = form.find('.ng-invalid:first');

					if (invalid.hasClass('ui-select-container')) {
						$scope.$broadcast(invalid.attr('name'));
						$window.setTimeout(function() {
							invalid.blur();
							$window.setTimeout(function() {
								$scope.$broadcast(invalid.attr('name'));
							}, 10 );
						}, 10 );
					} else {
						invalid.focus();
						$window.setTimeout(function() {
							invalid.blur();
							$window.setTimeout(function() {
								invalid.focus();
							}, 10 );
						}, 10 );
					}
				}
			};

			$('#offerte-form .js-select').change(rebuildSelect2());

			/* Na het opnieuw inladen van de rentetarieven moet de styling op de selectbox opnieuw geinitieerd worden. */
			$scope.getInterests = function()
			{
				if($scope.offerte.bezoeker.gewenstLeenbedrag < globals.minimumAmount)
				{
					$scope.offerte.bezoeker.gewenstLeenbedrag = globals.minimumAmount;
				}
				if($scope.offerte.bezoeker.gewenstLeenbedrag > globals.maximumAmount)
				{
					$scope.offerte.bezoeker.gewenstLeenbedrag = globals.maximumAmount;
				}
				var bank ='';
				if($scope.gewensteBank !== '') {
					bank = $scope.gewensteBank;
				} else if ($scope.affiliateBank !== '') {
					bank = $scope.affiliateBank;
				}
				// showpl en showdk op true laten staan om alle rentetarieven binnen te krijgen.
				var data = {'showPl':true, 'showDk': true, 'amounts': [$scope.offerte.bezoeker.gewenstLeenbedrag], 'bank' : bank};
				$http.post('/ajax/getInterests/', data)
				.success(function(response){
					$scope.interests = response;
					$scope.setDurationOptions();
					$scope.setPaymentOptions();
				});
			};

			$scope.getAddress = function(){

				if($scope.offerte.bezoeker.postcode !== '' && $scope.offerte.bezoeker.huisnummer !== '' && $scope.offerte.bezoeker.postcode !== undefined && $scope.offerte.bezoeker.huisnummer !== undefined)
				{
					$scope.disableAddress = true;
					$http.post('/ajax/getAddress/', {'postcode' : $scope.offerte.bezoeker.postcode, 'huisnummer' : $scope.offerte.bezoeker.huisnummer}).
						success(function(data, status, headers, config) {
						$scope.disableAddress = false;
						if(typeof data.straatnaam != 'undefined' && typeof data.plaatsnaam != 'undefined')
						{
							$scope.offerte.bezoeker.straat = data.straatnaam;
							$scope.offerte.bezoeker.woonplaats = data.plaatsnaam;
						}
					});
				}
			};

			$scope.getBankLogo = function(bankName, getSrcSet){
				if(typeof getSrcSet === 'undefined'){
					getSrcSet = false;
				}
				var imgName = {
					'ABN Amro' : 'abnamro',
					'BNP' : 'bnp-paribas',
					'defam' : 'defam',
					'defam premium' : 'defam',
					'Directa' : 'directa',
					'Findio' : 'findio',
					'Freo' : 'freo',
					'ING' : 'ing',
					'interbank' : 'interbank',
					'MoneYou' : 'moneyou',
					'Nationale Nederlanden' : 'nationale-nederlanden',
					'Qander' : 'qander',
					'Rabobank' : 'rabobank',
					'Santander' : 'santander',
					'SNS Bank' : 'snsbank',
					'LS' : 'lender-spender',
				};
				if(typeof imgName[bankName] !== 'undefined'){
					if(getSrcSet){
						return "/img/bank-logo/"+imgName[bankName]+".png, /img/bank-logo/"+imgName[bankName]+"_x2.png 2x";
					}else{
						return "/img/bank-logo/"+imgName[bankName]+".png";
					}
				} else{
					return false;
				}
			};

			/* Na het opnieuw inladen van de rentetarieven moet de styling op de selectbox opnieuw geinitieerd worden. */
			$scope.isRecommendedLoan = function()
			{
				if ($scope.offerte.bezoeker.bestedingsdoel == 'Auto' ||
					$scope.offerte.bezoeker.bestedingsdoel == 'Recreatiewoning' ||
					$scope.offerte.bezoeker.bestedingsdoel == 'Woningverbetering' ||
					$scope.offerte.bezoeker.bestedingsdoel == 'Schulden aflossen' ||
					$scope.offerte.bezoeker.bestedingsdoel == 'Restschuld woning') {

					$scope.recommendedLoan = 'pl';
					if ($scope.offerte.bezoeker.productvorm == '' || $scope.offerte.bezoeker.productvorm == undefined) {
						$scope.offerte.bezoeker.productvorm = 'Persoonlijke lening';
					}

				}else if ($scope.offerte.bezoeker.bestedingsdoel == 'Alternatief rood staan' ||
					$scope.offerte.bezoeker.bestedingsdoel == 'Meerdere kleine aankopen' ||
					$scope.offerte.bezoeker.bestedingsdoel == 'Extra financiele ruimte') {

					$scope.recommendedLoan = 'dk';
					if ($scope.offerte.bezoeker.productvorm == '' || $scope.offerte.bezoeker.productvorm == undefined) {
						$scope.offerte.bezoeker.productvorm = 'Doorlopend krediet';
					}

				} else if ($scope.offerte.bezoeker.bestedingsdoel == '' ||
					$scope.offerte.bezoeker.bestedingsdoel == 'Lagere rente' ||
					$scope.offerte.bezoeker.bestedingsdoel == 'Lagere maandlast' ||
					$scope.offerte.bezoeker.bestedingsdoel == 'Leningen oversluiten' ||
					$scope.offerte.bezoeker.bestedingsdoel == 'Anders') {

					if ($scope.offerte.bezoeker.productvorm == '' || $scope.offerte.bezoeker.productvorm == undefined) {
						$scope.offerte.bezoeker.productvorm = 'Persoonlijk advies';
					} else {
						$scope.recommendedLoan = 'pa';
					}

				} else {
					if ($scope.offerte.bezoeker.productvorm == '' || $scope.offerte.bezoeker.productvorm == undefined) {
						$scope.offerte.bezoeker.productvorm = 'Persoonlijk advies';
					} else {
						$scope.recommendedLoan = 'pa';
					}
				}
			};

			$scope.$watch('offerte.emailadres', function(){
				var emailme = new RegExp('.@me\.com');
				var emailicloud = new RegExp('.@icloud\.com');

				if (emailme.test($scope.offerte.emailadres)) {
					$scope.warningAtMe = true;
					$scope.warningAtICloud = false;
				}else if (emailicloud.test($scope.offerte.emailadres)) {
					$scope.warningAtICloud = true;
					$scope.warningAtMe = false;
				}else{
					$scope.warningAtMe = false;
					$scope.warningAtICloud = false;
				}
			}, true);


			function rebuildSelect2()
			{
				$window.setTimeout(function() {
					$("#offerte-form select.js-select").not('.select2-hidden-accessible').select2({
						minimumResultsForSearch: -1,
						width: '100%',
						theme: 'pwc',
						dropdownAutoWidth: 'true'
					});
				}, 10 );
			}

			function last65years()
			{
				var startYear = new Date().getFullYear();
				var endYear = startYear - 65;
				var years = [];

				for(var i=startYear; i > endYear; i--) {
					years.push(i);
				}
				return years;
			}

			$scope.offerte.wonend_sinds = '3-9';

			$scope.offerte.bkr = 'nee';
			$scope.offerte.bkr_permission = true;

			var defaultAanhef = "M";
			var defaultNationaliteit = "Nederlands";
			var defaultNee = "N";
			var defaultInkomen = "4";
			var defaultInkomenPeriode = "per maand";

			$scope.offerte.aanhef = defaultAanhef;
			$scope.offerte.partnerAanhef = defaultAanhef;
			$scope.offerte.nationaliteit = defaultNationaliteit;
			$scope.offerte.partnerNationaliteit = defaultNationaliteit;
			$scope.offerte.gescheiden = defaultNee;
			$scope.offerte.partnerGescheiden = defaultNee;
			$scope.offerte.overigInkomst = defaultInkomen;
			$scope.offerte.partnerOverigInkomst = defaultInkomen;
			$scope.offerte.brutoPeriode = defaultInkomenPeriode;
			$scope.offerte.nettoPeriode = defaultInkomenPeriode;
			$scope.offerte.uitkeringNettoPeriode = defaultInkomenPeriode;
			$scope.offerte.overigBrutoPeriode = defaultInkomenPeriode;
			$scope.offerte.overigNettoPeriode = defaultInkomenPeriode;
			$scope.offerte.overigUitkeringNettoPeriode = defaultInkomenPeriode;
			$scope.offerte.partnerBrutoPeriode = defaultInkomenPeriode;
			$scope.offerte.partnerNettoPeriode = defaultInkomenPeriode;
			$scope.offerte.partnerUitkeringNettoPeriode = defaultInkomenPeriode;
			$scope.offerte.partnerOverigBrutoPeriode = defaultInkomenPeriode;
			$scope.offerte.partnerOverigNettoPeriode = defaultInkomenPeriode;
			$scope.offerte.partnerOverigUitkeringNettoPeriode = defaultInkomenPeriode;
			$scope.offerte.bezoeker.postcode = ($scope.offerte.bezoeker.postcode !== '' ? $scope.offerte.bezoeker.postcode : null);
			$scope.offerte.bezoeker.huisnummer = ($scope.offerte.bezoeker.huisnummer !== '' ? $scope.offerte.bezoeker.huisnummer : null);
			$scope.offerte.bezoeker.straat = ($scope.offerte.bezoeker.straat !== '' ? $scope.offerte.bezoeker.straat : null);
			$scope.offerte.bezoeker.woonplaats = ($scope.offerte.bezoeker.woonplaats !== '' ? $scope.offerte.bezoeker.woonplaats : null);
			$scope.offerte.bezoeker.telefoonnummer = ($scope.offerte.bezoeker.telefoonnummer !== '' ? $scope.offerte.bezoeker.telefoonnummer : null);

			$scope.offerte.gehuwd_sinds = new Date().getFullYear();

			$scope.productvormOptions = [
				'Persoonlijke lening',
				'Doorlopend krediet',
				'Persoonlijk advies'
			];
			$scope.inkomstenOptions = [
				{id: "1", text: 'Loondienst'},
				{id: "2", text: 'Uitkering/pensioen'},
				{id: "3", text: 'Zelfstandig ondernemer'},
				{id: "4", text: 'Geen inkomsten'}
			];
			$scope.overigeInkomstenOptions = [
				{id: "1", text: '2e inkomen loondienst'},
				{id: "2", text: 'Uitkering/pensioen'},
				{id: "3", text: 'Zelfstandig ondernemer'},
				{id: "4", text: 'Geen inkomsten'}
			];
			$scope.dienstverbandenOptions = [
				{id: "1", text: 'Vast dienstverband voor onbepaalde tijd'},
				{id: "3", text: 'Tijdelijk dienstverband'},
				{id: "6", text: 'Baan via een uitzendbureau'}
			];
			$scope.uitzendFasesOptions = [
				{id: "A", text: 'Fase A'},
				{id: "B", text: 'Fase B'},
				{id: "C", text: 'Fase C'}
			];
			$scope.inkomenPeriodeOptions = [
				{id : "per maand", text : "Per maand"},
				{id : "per 4 weken", text : "Per 4 weken"},
				{id : "per week", text : "Per week"}
			];
			$scope.uitkeringOptions = [
				{id : "174", text : "AOW/Ouderdomspensioen"},
				{id : "172", text : "WW/Werkloosheid"},
				{id : "171", text : "ABW/Bijstand/PGB"},
				{id : "173", text : "WAO/WIA/Arbeidsongeschiktheid"},
				{id : "anders", text : "Anders"}
			];
			$scope.rechtsvormOptions = [
				{id : "Eenmanszaak", text : "Eenmanszaak"},
				{id : "VOF", text : "Vennootschap onder firma (vof)"},
				{id : "CV", text : "Commanditaire vennootschap (cv)"},
				{id : "Maatschap", text : "Maatschap"},
				{id : "BV", text : "Besloten vennootschap (bv)"},
				{id : "NV", text : "Naamloze vennootschap (nv)"},
				{id : "Vereniging", text : "Vereniging"},
				{id : "Cooperatie", text : "Coöperatie en onderlinge waarborgmaatschappij"},
				{id : "Stichting", text : "Stichting"}
			];
			$scope.verblijfOptions = [
				{id : 1, text : "Verblijfsdocument type 1: regulier bepaalde tijd"},
				{id : 2, text : "Verblijfsdocument type 2: regulier onbepaalde tijd"},
				{id : 3, text : "Verblijfsdocument type 3: asiel bepaalde tijd"},
				{id : 4, text : "Verblijfsdocument type 4: asiel onbepaalde tijd"},
				{id : 5, text : "Verblijfsdocument EUR/EER"}
			];
			$scope.gescheidenSindsOptions = [
				{id : "<5", text : "Minder dan 6 jaar"},
				{id : "6-12", text : "6 tot 12 jaar"},
				{id : ">12", text : "Meer dan 12 jaar"}
			];
			$scope.jaNeeOptions = [
				{id : "N", text : "Nee"},
				{id : "J", text : "Ja"}
			];
			$scope.aanhefOptions = [
				{id : "M", text : "De heer"},
				{id : "V", text : "Mevrouw"}
			];
			$scope.jarenOptions = last65years();
			$scope.landOptions = [
				{id : "Nederlands", text : "Nederlands"},
				{id : "anders", text : "Anders"}
			];
			$scope.landenOptions = [
				{id : 'BEL', text : "België"},
				{id : 'DEU', text : "Duitsland"},
				{id : 'FRA', text : "Frankrijk"},
				{id : 'MAR', text : "Marokko"},
				{id : 'TUR', text : "Turkije"},
				{id : 'GBR', text : "Verenigd koninkrijk"},
				{id : 'BGR', text : "Bulgarije"},
				{id : 'CYP', text : "Cyprus"},
				{id : 'DNK', text : "Denemarken"},
				{id : 'EST', text : "Estland"},
				{id : 'FIN', text : "Finland"},
				{id : 'GRC', text : "Griekenland"},
				{id : 'HUN', text : "Hongarije"},
				{id : 'IRL', text : "Ierland"},
				{id : 'ITA', text : "Italië"},
				{id : 'LVA', text : "Letland"},
				{id : 'LTU', text : "Litouwen"},
				{id : 'LUX', text : "Luxemburg"},
				{id : 'MLT', text : "Malta"},
				{id : 'AUT', text : "Oostenrijk"},
				{id : 'POL', text : "Polen"},
				{id : 'PRT', text : "Portugal"},
				{id : 'ROM', text : "Roemenië"},
				{id : 'SVN', text : "Slovenië"},
				{id : 'SVK', text : "Slowakije"},
				{id : 'ESP', text : "Spanje"},
				{id : 'CZE', text : "Tsjechië"},
				{id : 'SWE', text : "Zweden"},
				{id : 'AFG', text : "Afghanistan"},
				{id : 'ALB', text : "Albanië"},
				{id : 'DZA', text : "Algerije"},
				{id : 'AND', text : "Andorra"},
				{id : 'AGO', text : "Angola"},
				{id : 'AIA', text : "Anguilla"},
				{id : 'ATA', text : "Antarctica"},
				{id : 'ATG', text : "Antigua/barbuda"},
				{id : 'ARG', text : "Argentinië"},
				{id : 'ARM', text : "Armenië"},
				{id : 'ABW', text : "Aruba"},
				{id : 'AUS', text : "Australië"},
				{id : 'AZE', text : "Azerbaidzjan"},
				{id : 'BHS', text : "Bahama's"},
				{id : 'BHR', text : "Bahrein"},
				{id : 'BGD', text : "Bangladesh"},
				{id : 'BRB', text : "Barbados"},
				{id : 'BLZ', text : "Belize"},
				{id : 'BEN', text : "Benin"},
				{id : 'BMU', text : "Bermuda"},
				{id : 'BTN', text : "Bhutan"},
				{id : 'BOL', text : "Bolivia"},
				{id : 'BIH', text : "Bosnië-hercegovina"},
				{id : 'BWA', text : "Botswana"},
				{id : 'BVT', text : "Bouvet"},
				{id : 'BRA', text : "Brazilië"},
				{id : 'IOT', text : "Britse Indische Eilanden"},
				{id : 'BRN', text : "Brunei"},
				{id : 'BFA', text : "Burkina Faso"},
				{id : 'BDI', text : "Burundi"},
				{id : 'KHM', text : "Cambodja"},
				{id : 'CAN', text : "Canada"},
				{id : 'CYM', text : "Cayman Eilanden"},
				{id : 'CAF', text : "Centraal Afrika"},
				{id : 'CHL', text : "Chili"},
				{id : 'CHN', text : "China"},
				{id : 'CXR', text : "Christmas Eilanden"},
				{id : 'CCK', text : "Cocoseilanden"},
				{id : 'COL', text : "Colombia"},
				{id : 'COM', text : "Comoren"},
				{id : 'COK', text : "Cookeilanden"},
				{id : 'CRI', text : "Costa rica"},
				{id : 'CUB', text : "Cuba"},
				{id : 'DJI', text : "Djibouti"},
				{id : 'DMA', text : "Dominica"},
				{id : 'DOM', text : "Dominicaanse Republiek"},
				{id : 'EGY', text : "Egypte"},
				{id : 'SLV', text : "El Salvador"},
				{id : 'ECU', text : "Equador"},
				{id : 'GNQ', text : "Equatoriaal Guinea"},
				{id : 'ERI', text : "Eritrea"},
				{id : 'ETH', text : "Ethiopië"},
				{id : 'FLK', text : "Falkland Eilanden"},
				{id : 'FRO', text : "Faroe Eilanden"},
				{id : 'FJI', text : "Fiji Eilanden"},
				{id : 'PHL', text : "Filipijnen"},
				{id : 'GUF', text : "Frans Guyana"},
				{id : 'PYF', text : "Frans Polynesië"},
				{id : 'ATF', text : "Frans Zuidelijk Territorium"},
				{id : 'GAB', text : "Gabon"},
				{id : 'GMB', text : "Gambia"},
				{id : 'GEO', text : "Georgïe"},
				{id : 'SGS', text : "Georgïe, Zuid,"},
				{id : 'GHA', text : "Ghana"},
				{id : 'GIB', text : "Gibraltar"},
				{id : 'GRD', text : "Grenada"},
				{id : 'GRL', text : "Groenland"},
				{id : 'GLP', text : "Guadeloupe"},
				{id : 'GUM', text : "Guam"},
				{id : 'GTM', text : "Guatemala"},
				{id : 'GIN', text : "Guinee"},
				{id : 'GNB', text : "Guinee-Bissau"},
				{id : 'GUY', text : "Guyana"},
				{id : 'HTI', text : "Haïti"},
				{id : 'HMD', text : "Heard/Mcdonald"},
				{id : 'SHN', text : "Helena, Sint"},
				{id : 'HND', text : "Honduras"},
				{id : 'HKG', text : "Hongkong"},
				{id : 'ISL', text : "Ijsland"},
				{id : 'IND', text : "India"},
				{id : 'IDN', text : "Indonesië"},
				{id : 'IRQ', text : "Irak"},
				{id : 'IRN', text : "Iran"},
				{id : 'ISR', text : "Israel"},
				{id : 'CIV', text : "Ivoorkust"},
				{id : 'JAM', text : "Jamaica"},
				{id : 'JPN', text : "Japan"},
				{id : 'YEM', text : "Jemen"},
				{id : 'YUG', text : "Joegoslavië"},
				{id : 'JOR', text : "Jordanië"},
				{id : 'CPV', text : "Kaapverdië"},
				{id : 'CMR', text : "Kameroen"},
				{id : 'QAT', text : "Katar"},
				{id : 'KAZ', text : "Kazachstan"},
				{id : 'KEN', text : "Kenya"},
				{id : 'KGZ', text : "Kirgiezië"},
				{id : 'KIR', text : "Kiribati"},
				{id : 'KNA', text : "Kitts, Sint, en"},
				{id : 'COG', text : "Kongo"},
				{id : 'HRV', text : "Kroatië"},
				{id : 'KWT', text : "Kuweit"},
				{id : 'LAO', text : "Laos"},
				{id : 'LSO', text : "Lesotho"},
				{id : 'LBN', text : "Libanon"},
				{id : 'LBR', text : "Liberia"},
				{id : 'LBY', text : "Libië"},
				{id : 'LIE', text : "Liechtenstein"},
				{id : 'LCA', text : "Lucia, sint"},
				{id : 'VGB', text : "Maagdeneilanden (Engeland)"},
				{id : 'VIR', text : "Maagdeneilanden (VS)"},
				{id : 'MAC', text : "Macau"},
				{id : 'MDG', text : "Madagascar"},
				{id : 'MWI', text : "Malawi"},
				{id : 'MDV', text : "Maldiven"},
				{id : 'MYS', text : "Maleisië"},
				{id : 'MLI', text : "Mali"},
				{id : 'MNP', text : "Mariana Eilanden"},
				{id : 'MHL', text : "Marshall Eilanden"},
				{id : 'MTQ', text : "Martinique"},
				{id : 'MRT', text : "Mauritanië"},
				{id : 'MUS', text : "Mauritius"},
				{id : 'MYT', text : "Mayotte"},
				{id : 'MEX', text : "Mexico"},
				{id : 'FSM', text : "Micronesië"},
				{id : 'MDA', text : "Moldavië"},
				{id : 'MCO', text : "Monaco"},
				{id : 'MNG', text : "Mongolië"},
				{id : 'MSR', text : "Montserrat"},
				{id : 'MOZ', text : "Mozambique"},
				{id : 'MMR', text : "Myanmar"},
				{id : 'NAM', text : "Namibië"},
				{id : 'NRU', text : "Nauru"},
				{id : 'ANT', text : "Nederlandse Antillen"},
				{id : 'NPL', text : "Nepal"},
				{id : 'NIC', text : "Nicaragua"},
				{id : 'NCL', text : "Nieuw-Caledonië"},
				{id : 'NZL', text : "Nieuw-Zeeland"},
				{id : 'NER', text : "Niger"},
				{id : 'NGA', text : "Nigeria"},
				{id : 'NIU', text : "Niue"},
				{id : 'PRK', text : "Noord-Korea"},
				{id : 'NOR', text : "Noorwegen"},
				{id : 'NFK', text : "Norfolk"},
				{id : 'UGA', text : "Oeganda"},
				{id : 'UKR', text : "Oekraïne"},
				{id : 'UZB', text : "Oezbekistan"},
				{id : 'OMN', text : "Oman"},
				{id : 'TMP', text : "Oost-timor"},
				{id : 'PAK', text : "Pakistan"},
				{id : 'PLW', text : "Palau"},
				{id : 'PAN', text : "Panama"},
				{id : 'PNG', text : "Papua Nieuw-Guinea"},
				{id : 'PRY', text : "Paraguay"},
				{id : 'PER', text : "Peru"},
				{id : 'SPM', text : "Pierre, Sint, en Miquelon"},
				{id : 'PCN', text : "Pitcairn Eiland"},
				{id : 'PRI', text : "Puerto Rico"},
				{id : 'REU', text : "Reunion"},
				{id : 'RUS', text : "Rusland"},
				{id : 'RWA', text : "Rwanda"},
				{id : 'WSM', text : "Samoa-Eilanden"},
				{id : 'ASM', text : "Samoa-Eilanden,"},
				{id : 'SMR', text : "San marino"},
				{id : 'STP', text : "Sao Tome en Principe"},
				{id : 'SAU', text : "Saudi-arabië"},
				{id : 'SEN', text : "Senegal"},
				{id : 'SYC', text : "Seychellen"},
				{id : 'SLE', text : "Sierra leone"},
				{id : 'SGP', text : "Singapore"},
				{id : 'SLB', text : "Solomon Eilanden"},
				{id : 'SOM', text : "Somalië"},
				{id : 'LKA', text : "Sri Lanka"},
				{id : 'SDN', text : "Sudan"},
				{id : 'SUR', text : "Suriname"},
				{id : 'SJM', text : "Svalbard en Jan Mayen Eilanden"},
				{id : 'SWZ', text : "Swaziland"},
				{id : 'SYR', text : "Syrië"},
				{id : 'TJK', text : "Tadzjikistan"},
				{id : 'TWN', text : "Taiwan"},
				{id : 'TZA', text : "Tanzania"},
				{id : 'THA', text : "Thailand"},
				{id : 'TGO', text : "Togo"},
				{id : 'TKL', text : "Tokelau"},
				{id : 'TON', text : "Tonga"},
				{id : 'TTO', text : "Trinidad &amp; Tobago"},
				{id : 'TCD', text : "Tsjaad"},
				{id : 'TUN', text : "Tunesië"},
				{id : 'TKM', text : "Turkmenistan"},
				{id : 'TCA', text : "Turkse en Caicos Eilanden"},
				{id : 'TUV', text : "Tuvalu"},
				{id : 'URY', text : "Uruguay"},
				{id : 'VUT', text : "Vanuatu"},
				{id : 'VAT', text : "Vaticaanstad"},
				{id : 'VEN', text : "Venezuela"},
				{id : 'ARE', text : "Verenigde Arabibische Emiraten"},
				{id : 'USA', text : "Verenigde Staten van Amerika"},
				{id : 'UMI', text : "Verenigde Staten, Eilanden van"},
				{id : 'VNM', text : "Vietnam"},
				{id : 'VCT', text : "Vincent, sint,"},
				{id : 'WLF', text : "Wallis Archipel"},
				{id : 'ESH', text : "Westelijke Sahara"},
				{id : 'BLR', text : "Wit-rusland"},
				{id : 'ZMB', text : "Zambia"},
				{id : 'ZAR', text : "Zaïre"},
				{id : 'ZWE', text : "Zimbabwe"},
				{id : 'ZAF', text : "Zuid-afrika"},
				{id : 'KOR', text : "Zuid-korea"},
				{id : 'CHE', text : "Zwitserland"}
			];

			$scope.getInterests();
			$scope.isRecommendedLoan();

			$scope.bestedingsdoelen = {
				'Auto' : {
					'pl': {
						'options' : {
							1 : {'label' : 'Eenmalig een vast bedrag lenen', 'sign' : 'plus'},
							2 : {'label' : 'Vaste rente',                    'sign' : 'plus'},
							3 : {'label' : 'Vaste looptijd',                 'sign' : 'plus'},
							4 : {'label' : 'Vaste aflossing',                'sign' : 'plus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					},
					'dk' : {
						'options' : {
							1 : {'label' : 'Tussentijds opnieuw opnemen',    'sign' : 'plus'},
							2 : {'label' : 'Variabele rente',                 'sign' : 'minus'},
							3 : {'label' : 'Variabele looptijd',              'sign' : 'minus'},
							4 : {'label' : 'Restschuld risico',              'sign' : 'minus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					}
				},
				'Woningverbetering' : {
					'pl': {
						'options' : {
							1 : {'label' : 'Eenmalig een vast bedrag lenen', 'sign' : 'plus'},
							2 : {'label' : 'Vaste rente',                    'sign' : 'plus'},
							3 : {'label' : 'Vaste looptijd',                 'sign' : 'plus'},
							4 : {'label' : 'Vaste aflossing',                'sign' : 'plus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					},
					'dk' : {
						'options' : {
							1 : {'label' : 'Tussentijds opnieuw opnemen',    'sign' : 'plus'},
							2 : {'label' : 'Variabele rente',                 'sign' : 'minus'},
							3 : {'label' : 'Variabele looptijd',              'sign' : 'minus'},
							4 : {'label' : 'Restschuld risico',              'sign' : 'minus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					}
				},
				'Schulden aflossen' : {
					'pl': {
						'options' : {
							1 : {'label' : 'Eenmalig een vast bedrag lenen', 'sign' : 'plus'},
							2 : {'label' : 'Vaste rente',                    'sign' : 'plus'},
							3 : {'label' : 'Vaste looptijd',                 'sign' : 'plus'},
							4 : {'label' : 'Vaste aflossing',                'sign' : 'plus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					},
					'dk' : {
						'options' : {
							1 : {'label' : 'Tussentijds opnieuw opnemen',    'sign' : 'minus'},
							2 : {'label' : 'Variabele rente',                 'sign' : 'minus'},
							3 : {'label' : 'Variabele looptijd',              'sign' : 'minus'},
							4 : {'label' : 'Restschuld risico',              'sign' : 'minus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					}
				},
				'Recreatiewoning' : {
					'pl': {
						'options' : {
							1 : {'label' : 'Eenmalig een vast bedrag lenen', 'sign' : 'plus'},
							2 : {'label' : 'Vaste rente',                    'sign' : 'plus'},
							3 : {'label' : 'Vaste looptijd',                 'sign' : 'plus'},
							4 : {'label' : 'Vaste aflossing',                'sign' : 'plus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					},
					'dk' : {
						'options' : {
							1 : {'label' : 'Tussentijds opnieuw opnemen',    'sign' : 'plus'},
							2 : {'label' : 'Variabele rente',                 'sign' : 'minus'},
							3 : {'label' : 'Variabele looptijd',              'sign' : 'minus'},
							4 : {'label' : 'Restschuld risico',              'sign' : 'minus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					}
				},
				'Restschuld woning' : {
					'pl': {
						'options' : {
							1 : {'label' : 'Eenmalig een vast bedrag lenen', 'sign' : 'plus'},
							2 : {'label' : 'Vaste rente',                    'sign' : 'plus'},
							3 : {'label' : 'Vaste looptijd',                 'sign' : 'plus'},
							4 : {'label' : 'Vaste aflossing',                'sign' : 'plus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					},
					'dk' : {
						'options' : {
							1 : {'label' : 'Tussentijds opnieuw opnemen',    'sign' : 'minus'},
							2 : {'label' : 'Variabele rente',                 'sign' : 'minus'},
							3 : {'label' : 'Variabele looptijd',              'sign' : 'minus'},
							4 : {'label' : 'Restschuld risico',              'sign' : 'minus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					}
				},
				'Meerdere kleine aankopen' : {
					'pl': {
						'options' : {
							1 : {'label' : 'Eenmalig een vast bedrag lenen', 'sign' : 'plus'},
							2 : {'label' : 'Vaste rente',                    'sign' : 'plus'},
							3 : {'label' : 'Vaste looptijd',                 'sign' : 'plus'},
							4 : {'label' : 'Vaste aflossing',                'sign' : 'plus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					},
					'dk' : {
						'options' : {
							1 : {'label' : 'Tussentijds opnieuw opnemen',    'sign' : 'plus'},
							2 : {'label' : 'Variabele rente',                 'sign' : 'minus'},
							3 : {'label' : 'Variabele looptijd',              'sign' : 'minus'},
							4 : {'label' : 'Restschuld risico',              'sign' : 'minus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					}
				},
				'Extra financiele ruimte' : {
					'pl': {
						'options' : {
							1 : {'label' : 'Eenmalig een vast bedrag lenen', 'sign' : 'minus'},
							2 : {'label' : 'Vaste rente',                    'sign' : 'plus'},
							3 : {'label' : 'Vaste looptijd',                 'sign' : 'minus'},
							4 : {'label' : 'Vaste aflossing',                'sign' : 'plus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					},
					'dk' : {
						'options' : {
							1 : {'label' : 'Tussentijds opnieuw opnemen',    'sign' : 'plus'},
							2 : {'label' : 'Variabele rente',                 'sign' : 'minus'},
							3 : {'label' : 'Variabele looptijd',              'sign' : 'minus'},
							4 : {'label' : 'Restschuld risico',              'sign' : 'minus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					}
				},
				'Alternatief rood staan' : {
					'pl': {
						'options' : {
							1 : {'label' : 'Eenmalig een vast bedrag lenen', 'sign' : 'minus'},
							2 : {'label' : 'Vaste rente',                    'sign' : 'plus'},
							3 : {'label' : 'Vaste looptijd',                 'sign' : 'plus'},
							4 : {'label' : 'Vaste aflossing',                'sign' : 'plus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					},
					'dk' : {
						'options' : {
							1 : {'label' : 'Tussentijds opnieuw opnemen',    'sign' : 'plus'},
							2 : {'label' : 'Variabele rente',                 'sign' : 'minus'},
							3 : {'label' : 'Variabele looptijd',              'sign' : 'minus'},
							4 : {'label' : 'Restschuld risico',              'sign' : 'minus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					}
				},
				'Lagere maandlast' : {
					'pl': {
						'options' : {
							1 : {'label' : 'Eenmalig een vast bedrag lenen', 'sign' : 'plus'},
							2 : {'label' : 'Vaste rente',                    'sign' : 'plus'},
							3 : {'label' : 'Vaste looptijd',                 'sign' : 'plus'},
							4 : {'label' : 'Vaste aflossing',                'sign' : 'plus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					},
					'dk' : {
						'options' : {
							1 : {'label' : 'Tussentijds opnieuw opnemen',    'sign' : 'minus'},
							2 : {'label' : 'Variabele rente',                 'sign' : 'minus'},
							3 : {'label' : 'Variabele looptijd',              'sign' : 'minus'},
							4 : {'label' : 'Restschuld risico',              'sign' : 'minus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					}
				},
				'Lagere rente' : {
					'pl': {
						'options' : {
							1 : {'label' : 'Eenmalig een vast bedrag lenen', 'sign' : 'plus'},
							2 : {'label' : 'Vaste rente',                    'sign' : 'plus'},
							3 : {'label' : 'Vaste looptijd',                 'sign' : 'plus'},
							4 : {'label' : 'Vaste aflossing',                'sign' : 'plus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					},
					'dk' : {
						'options' : {
							1 : {'label' : 'Tussentijds opnieuw opnemen',    'sign' : 'minus'},
							2 : {'label' : 'Variabele rente',                 'sign' : 'minus'},
							3 : {'label' : 'Variabele looptijd',              'sign' : 'minus'},
							4 : {'label' : 'Restschuld risico',              'sign' : 'minus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					}
				},
				'Leningen oversluiten' : {
					'pl': {
						'options' : {
							1 : {'label' : 'Eenmalig een vast bedrag lenen', 'sign' : 'plus'},
							2 : {'label' : 'Vaste rente',                    'sign' : 'plus'},
							3 : {'label' : 'Vaste looptijd',                 'sign' : 'plus'},
							4 : {'label' : 'Vaste aflossing',                'sign' : 'plus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					},
					'dk' : {
						'options' : {
							1 : {'label' : 'Tussentijds opnieuw opnemen',    'sign' : 'minus'},
							2 : {'label' : 'Variabele rente',                 'sign' : 'minus'},
							3 : {'label' : 'Variabele looptijd',              'sign' : 'minus'},
							4 : {'label' : 'Restschuld risico',              'sign' : 'minus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					}
				},
				'Anders' : {
					'pl': {
						'options' : {
							1 : {'label' : 'Eenmalig een vast bedrag lenen', 'sign' : 'plus'},
							2 : {'label' : 'Vaste rente',                    'sign' : 'plus'},
							3 : {'label' : 'Vaste looptijd',                 'sign' : 'plus'},
							4 : {'label' : 'Vaste aflossing',                'sign' : 'plus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					},
					'dk' : {
						'options' : {
							1 : {'label' : 'Tussentijds opnieuw opnemen',    'sign' : 'minus'},
							2 : {'label' : 'Variabele rente',                 'sign' : 'minus'},
							3 : {'label' : 'Variabele looptijd',              'sign' : 'minus'},
							4 : {'label' : 'Restschuld risico',              'sign' : 'minus'},
							5 : {'label' : 'Boetevrij extra aflossen',       'sign' : 'plus'},
						}
					}
				},
			};
		}
	};
}]);